<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">联系我们</h1>
              <h3 class="font-weight-light mt-3">
                无论您需要开源源码、定制开发，还是网站搭建与线上服务，
                欢迎随时联系我们，我们将竭诚为您服务。
              </h3>
              <h3 class="font-weight-light mt-3">
                邮箱：286350288@qq.com
              </h3>
              <h3 class="font-weight-light mt-1">
                地址：安徽省六安市霍邱县城关镇城法制巷内西湖首府31幢302室
              </h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    label="您的姓名"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="您的邮箱"
                    required
                ></v-text-field>

                <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    label="留言内容"
                    required
                />

                <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                >
                  发送留言
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <v-snackbar
        v-model="snackbar.enabled"
        timeout="5000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
export default {
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "请输入您的姓名",
      (v) => (v && v.length >= 2) || "姓名至少需要 2 个字符",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "请输入您的邮箱",
      (v) => /.+@.+\..+/.test(v) || "请输入有效的邮箱地址",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "请输入留言内容",
      (v) => (v && v.length >= 5) || "留言内容至少需要 5 个字符",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  methods: {
    submit() {
      const subject = encodeURIComponent("官网咨询：" + this.name);
      const body = encodeURIComponent(
        "姓名：" + this.name +
        "\n邮箱：" + this.email +
        "\n\n留言内容：\n" + this.textArea
      );
      window.location.href = "mailto:286350288@qq.com?subject=" + subject + "&body=" + body;
      this.snackbar.text = "已为您打开邮件客户端，请点击发送即可送达"
      this.snackbar.color = "success"
      this.snackbar.enabled = true
    }
  }
};
</script>
